export default {
  title: "招募案件  我的最愛列表",
};
